import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";

import CurrencyCell from "../../../component/CurrencyCell";

const parseAmount = (value) => {
  if (value == null) return 0;

  let str = String(value).replace(/,/g, "").trim();

  // Handle trailing minus
  if (str.endsWith("-")) {
    str = "-" + str.slice(0, -1);
  }

  return Number(str) || 0;
};

export default function WGRTable({ rows = [] }) {
  return (
   
  <TableContainer
    sx={{
      width: "100%",
      maxWidth: "100%",
      overflowX: "auto",
      WebkitOverflowScrolling: "touch",
    }}
  >
    <Table
      size="small"
      sx={{
        minWidth: 750,
        width: "max-content",
        borderCollapse: "collapse",

        "& th, & td": {
          border: "1px solid #777",
          padding: {
            xs: "4px 6px",
            sm: "6px 8px",
          },
          fontSize: {
            xs: "11px",
            sm: "13px",
          },
          whiteSpace: "nowrap",
        },
      }}
    >
        <TableHead>
          {/* MAIN HEADINGS */}
          <TableRow>
            <TableCell
              align="center"
              sx={{
                backgroundColor: "#b6efb6",
                fontWeight: 800,
                fontSize: "16px",
              }}
            />

            <TableCell
              colSpan={4}
              align="center"
              sx={{
                backgroundColor: "#b6efb6",
                fontWeight: 800,
                fontSize: "16px",
              }}
            >
              DEBIT
            </TableCell>

            <TableCell
              colSpan={4}
              align="center"
              sx={{
                backgroundColor: "#f5b6b6",
                fontWeight: 800,
                fontSize: "16px",
              }}
            >
              CREDIT
            </TableCell>
          </TableRow>

          {/* COLUMN HEADINGS */}
          <TableRow>
            {[
              "Sr No.",
              "PARTICULARS",
              "OB",
              "During the Month",
              "End of the month",
              "PARTICULARS",
              "OB",
              "During the Month",
              "End of the month",
            ].map((heading, index) => (
              <TableCell
                key={index}
                align="center"
                sx={{
                  fontWeight: 700,
                  fontSize: "12px",
                  padding: "5px 4px",
                }}
              >
                {heading}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>

        <TableBody>
          {rows.map((row, index) => {
            // =========================
            // CHECK DEBIT PARTICULAR
            // =========================
            const debitParticular = String(
              row.drparticulars ?? ""
            ).trim();

            const debitHighlight =
              /total|net/i.test(debitParticular);

            // =========================
            // CHECK CREDIT PARTICULAR
            // =========================
            const creditParticular = String(
              row.CrParticulars ?? ""
            ).trim();

            const creditHighlight =
              /total|net/i.test(creditParticular);

            return (
              <TableRow
                key={index}
                hover
                sx={{
                  "&:nth-of-type(even)": {
                    bgcolor: "grey.50",
                  },
                }}
              >
                {/* =========================
                    SR NO
                ========================= */}
                <TableCell
                  align="center"
                  sx={{
                    fontSize: "11px",
                    padding: "3px 4px",
                  }}
                >
                  {row.srno}
                </TableCell>

                {/* =========================
                    DEBIT PARTICULARS
                ========================= */}
                <TableCell
                  align="left"
                  sx={{
                    fontSize: "11px",
                    padding: "3px 4px",

                    ...(debitHighlight && {
                      fontWeight: 800,
                      backgroundColor: "#fff9b0",
                    }),
                  }}
                >
                  {row.drparticulars}
                </TableCell>

                {/* =========================
                    DEBIT OB
                ========================= */}
                <TableCell
                  align="right"
                  sx={{
                    fontSize: "11px",
                    padding: "3px 4px",

                    ...(debitHighlight && {
                      fontWeight: 800,
                      backgroundColor: "#fff9b0",
                    }),
                  }}
                >
                  <CurrencyCell value={row.drOB} />
                </TableCell>

                {/* =========================
                    DEBIT CURRENT
                ========================= */}
                <TableCell
                  align="right"
                  sx={{
                    fontSize: "11px",
                    padding: "3px 4px",

                    ...(debitHighlight && {
                      fontWeight: 800,
                      backgroundColor: "#fff9b0",
                    }),
                  }}
                >
                  <CurrencyCell value={row.drCurrent} />
                </TableCell>

                {/* =========================
                    DEBIT CB
                ========================= */}
                <TableCell
                  align="right"
                  sx={{
                    fontSize: "11px",
                    padding: "3px 4px",

                    ...(debitHighlight && {
                      fontWeight: 800,
                      backgroundColor: "#fff9b0",
                    }),
                  }}
                >
                  <CurrencyCell value={row.drCB} />
                </TableCell>

                {/* =========================
                    CREDIT PARTICULARS
                ========================= */}
                <TableCell
                  align="left"
                  sx={{
                    fontSize: "11px",
                    padding: "3px 4px",

                    ...(creditHighlight && {
                      fontWeight: 800,
                      backgroundColor: "#f5b6b6",
                    }),
                  }}
                >
                  {row.CrParticulars}
                </TableCell>

                {/* =========================
                    CREDIT OB
                ========================= */}
                <TableCell
                  align="right"
                  sx={{
                    fontSize: "11px",
                    padding: "3px 4px",

                    ...(creditHighlight && {
                      fontWeight: 800,
                      backgroundColor: "#f5b6b6",
                    }),
                  }}
                >
                  <CurrencyCell value={row.crOB} />
                </TableCell>

                {/* =========================
                    CREDIT CURRENT
                ========================= */}
                <TableCell
                  align="right"
                  sx={{
                    fontSize: "11px",
                    padding: "3px 4px",

                    ...(creditHighlight && {
                      fontWeight: 800,
                      backgroundColor: "#f5b6b6",
                    }),
                  }}
                >
                  <CurrencyCell value={row.crCurrent} />
                </TableCell>

                {/* =========================
                    CREDIT CB
                ========================= */}
                <TableCell
                  align="right"
                  sx={{
                    fontSize: "11px",
                    padding: "3px 4px",

                    ...(creditHighlight && {
                      fontWeight: 800,
                      backgroundColor: "#f5b6b6",
                    }),
                  }}
                >
                  <CurrencyCell value={row.CrCB} />
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
}